import axios from "axios";

const earlyApply = (data) => {
  return new Promise((resolve, reject) => {
    axios.post(process.env.REACT_APP_BASE_URL + "/pre-customer", data)
      .then(response => resolve(response.data))
      .catch(error => reject(error));
  });
};

export default earlyApply;